import {
  START_REFRESHING,
  END_REFRESHING,
  USER_LOGOUT,
} from '../types';

const defaultState = {
  refresh: {
    refreshing: false,
    completed: false,
  },
};

const refresh = (state = defaultState.refresh, action) => {
  switch (action.type) {
    case START_REFRESHING: {
      return Object.assign({}, state, {
        refreshing: true,
        completed: false,
      });
    }

    case END_REFRESHING: {
      return Object.assign({}, state, {
        refreshing: false,
        completed: true,
      });
    }

    case USER_LOGOUT:
      return Object.assign({}, defaultState.refresh);

    default:
      return state;
  }
};

export default refresh;



// WEBPACK FOOTER //
// ./src/state/reducers/refresh.js